import { createAsyncThunk } from "@reduxjs/toolkit";
import newsletterService from "../../../api/services/newsletter";

export const createNewsletter = createAsyncThunk(
  "newsletters/create-newsletter",
  async (email) => {
    return await newsletterService.createNewsletter(email);
  }
);

export const getNewsletters = createAsyncThunk(
  "newsletters/get-newsletter",
  async (email) => {
    return await newsletterService.getNewsletters(email);
  }
);

export const deleteNewsletter = createAsyncThunk(
  "newsletters/delete-newsletter",
  async (newsletterId) => {
    return await newsletterService.deleteNewsletter(newsletterId);
  }
);

export const sendEmails = createAsyncThunk(
  "newsletters/send-emails",
  async ({ emailIds, subject, htmlContent }) => {
    return await newsletterService.sendEmails({ emailIds, subject, htmlContent });
  }
);
